import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MovimientoCamionindex } from "../edit/index";
import { StatusCamionListFiltro } from "../list/listfiltro";

export class MovimientosCamionIndex extends React.PureComponent {
    render() {
        return (
            <div>
                <kea.Title titulo="Movimientos de camión" />

                <MovimientoCamionindex />
                <StatusCamionListFiltro />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/container/index.tsx